export const appConfig = {
  features: {
    showTokenInspector: false
  },

  navigation: {
    items: {
      profile: {
        enabled: true,
        text: 'My Profile',
        path: '/profile',
        icon: 'user-alt'
      },
      customers: {
        enabled: false,
        text: 'Customers',
        path: '/customers',
        icon: 'users'
      },
      adminUsers: {
        enabled: false,
        text: 'Admin Users',
        path: '/adminusers',
        icon: 'AdminPanelSettingsOutlined'
      },
      webUsers: {
        enabled: true,
        text: 'Web Users',
        path: '/users',
        icon: 'PeopleAltRound'
      },
      tokenInspector: {
        enabled: true,
        text: 'Token Inspector',
        path: '/token-inspector',
        icon: 'Key'
      },
      dashboard: {
        enabled: true,
        text: 'Dashboard',
        path: '/dashboard',
        icon: 'DashboardFilled'
      },
      devices: {
        enabled: false,
        text: 'Devices',
        icon: 'ImportantDevicesFilled',
        children: {
          endDevices: {
            enabled: true,
            text: 'End Devices',
            path: '/devices/end',
            icon: 'DevicesOtherTwotone'
          },
          receivingDevices: {
            enabled: true,
            text: 'Receiving Devices',
            path: '/devices/receiving',
            icon: 'ImportantDevicesOutlined'
          }
        }
      },
      licenses: {
        enabled: false,
        text: 'Licenses',
        icon: 'License',
        children: {
          androidScreens: {
            enabled: true,
            text: 'Android Screens',
            path: '/licenses/screens',
            icon: 'Android'
          },
          promoCodes: {
            enabled: true,
            text: 'Promo Codes',
            path: '/licenses/codes',
            icon: 'Qrcode'
          }
        }
      },
      serialNumbers: {
        enabled: false,
        text: 'Serial Numbers',
        path: '/serialnumbers',
        icon: 'NumbersFilled'
      },
      billing: {
        enabled: true,
        text: 'Billing',
        path: '/billing',
        icon: 'MoneyBill'
      },
      mongodb: {
        enabled: false,
        text: 'Mongo Database',
        path: '/mongodb',
        icon: 'Database'
      },
      reports: {
        enabled: true,
        text: 'Reports',
        icon: 'LogoFirebase',
        children: {
          reportsDisplay: {
            enabled: true,
            text: 'Display Reports',
            path: '/reports/display',
            icon: 'SupervisedUserCircleRound'
          },
          reportsEmail: {
            enabled: true,
            text: 'Set Email Reports',
            path: '/reports/email',
            icon: 'PersonPinFilled'
          }
        }
      },
      firebase: {
        enabled: false,
        text: 'Firebase',
        icon: 'LogoFirebase',
        children: {
          firebaseUsers: {
            enabled: false,
            text: 'Users',
            path: '/firebase/users',
            icon: 'SupervisedUserCircleRound'
          },
          firebaseCustomers: {
            enabled: false,
            text: 'Customers',
            path: '/firebase/customers',
            icon: 'PersonPinFilled'
          },
          firebaseDashboard: {
            enabled: false,
            text: 'Dashboard',
            path: '/firebase/dashboard',
            icon: 'DashboardFilled'
          }
        }
      },
      mqttServer: {
        enabled: true,
        text: 'MQTT Accounts',
        path: '/mqttserver',
        icon: 'Server'
      },
      mobileAccounts: {
        enabled: true,
        text: 'Mobile Accounts',
        path: '/mobileAccounts',
        icon: 'Server'
      },
      androidApps: {
        enabled: true,
        text: 'Android Apps',
        path: '/androidapps',
        icon: 'ApplicationMobile'
      }
    }
  }
}
